import { render } from "./League.vue?vue&type=template&id=4e579ce6&scoped=true"
import script from "./League.vue?vue&type=script&lang=js"
export * from "./League.vue?vue&type=script&lang=js"

import "@/assets/css/news/index.css?vue&type=style&index=0&id=4e579ce6&lang=css&scoped=true"
import "./League.vue?vue&type=style&index=1&id=4e579ce6&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e579ce6"]])

export default __exports__